import React from 'react';
import Hero from './components/anti-ragging/Hero';
import Main from './components/anti-ragging/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const AntiRagging = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default AntiRagging;